import React, { useContext, useState } from 'react';

const INITIAL_STATE = {
  isFormSubmitting: false,
  showPassword: false,
  passwordScore: '',
  buyer: {
    buyerPassword: '',
    buyerEmail: '',
    buyerName: '',
    buyerPhone: '',
    offersEmail: true
  },
  company: {
    cnpj: '',
    corporateName: '',
    fantasyName: '',
    contactName: '',
    phone: '',
    phoneExtensionRegistry: '',
    nationalSimple: false,
    stateRegistry: '',
    taxInfo: '',
    billing: {
      address: '',
      neighborhood: '',
      city: '',
      state: '',
      reference: '',
      number: '',
      billingEmail: '',
      additionalInfo: '',
      zipCode: ''
    }
  },
  customerQualifyerData: {},
  buyerAlreadyRegistered: false,
  authorizeInfoShare: true,
  errors: {},
  companyFormStatus: 'FIRST_STEP'
};

const SignUpFormContext = React.createContext({
  state: INITIAL_STATE,
  updateState: () => {},
  resetState: () => {}
});

SignUpFormContext.displayName = 'SignUpFormContext';

export const SignUpFormProvider = ({ children }) => {
  const [state, setState] = useState(INITIAL_STATE);

  const updateState = obj => {
    setState(state => ({ ...state, ...obj }));
  };

  const resetState = () => {
    setState(INITIAL_STATE);
  };

  return (
    <SignUpFormContext.Provider value={{ state, updateState, resetState }}>
      {children}
    </SignUpFormContext.Provider>
  );
};

export const useSignUpFormContext = () => {
  const { state, updateState, resetState } = useContext(SignUpFormContext);
  return { ...state, updateState, resetState };
};
